import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_RELATED_PERSON_STATUS } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  UpdateRelatedPersonStatusPayload,
  UpdateRelatedPersonStatusResult,
} from '../types/updateRelatedPersonStatus.types';

export const updateRelatedPersonStatus = (builder: BuilderType) =>
  builder.mutation<UpdateRelatedPersonStatusResult, UpdateRelatedPersonStatusPayload>({
    query: (data) => ({
      data,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: UPDATE_RELATED_PERSON_STATUS,
    }),
    transformResponse: (response: GenericApiResponse<UpdateRelatedPersonStatusResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
